<template>
  <transition name="modal" id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="removePadding ? 'cleared-modal-container' : ''" :style="cssVars">

          <div class="modal-header" v-if="!disableHeader">
            <slot name="header">
            </slot>
          </div>

          <div :class="removePadding ? 'cleared-modal-body' : 'modal-body'">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer" v-if="!disableFooter">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    disableHeader: {
      required: false,
      default: false,
    },
    disableFooter: {
      required: false,
      default: false,
    },
    width: {
      required: false,
      default: 300,
    },
    removePadding: {
      required: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width': `${this.width}px`,
      };
    },
  },
};
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: var(--width);
    margin: 0px auto;
    padding: 10px 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  @media (max-width: 576px) {
    .modal-container {
      width: 100%;
    }
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .cleared-modal-body {
    margin: 0 !important;
    padding: 0 !important;
  }

  .cleared-modal-container{
    padding: 0 !important;
  }
</style>
